import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navbar } from '../components/Navbar';
import { Button } from '../components/ui/button';
import { User, Mail, Calendar, Shield, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-[#09090B]">
        <Navbar />
        <main className="pt-24 px-4">
          <div className="text-center">
            <p className="text-zinc-400">Cargando...</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090B]">
      <Navbar />
      
      <main className="pt-20 pb-12 px-4 md:px-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-heading text-3xl font-bold text-white mb-8">
            CONFIGURACIÓN
          </h1>

          {/* Profile Card */}
          <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl overflow-hidden">
            {/* Header */}
            <div className="bg-zinc-800/50 px-6 py-8 flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-[#00E599]/20 flex items-center justify-center">
                <User className="w-8 h-8 text-[#00E599]" />
              </div>
              <div>
                <h2 className="font-heading text-xl font-bold text-white">{user.name}</h2>
                <div className="flex items-center gap-2 text-zinc-400 text-sm">
                  <Mail className="w-4 h-4" />
                  {user.email}
                </div>
              </div>
            </div>

            {/* Details */}
            <div className="p-6 space-y-4">
              {/* Role */}
              <div className="flex items-center gap-3 p-4 bg-zinc-950 rounded-xl">
                <Shield className="w-5 h-5 text-[#6366F1]" />
                <div>
                  <span className="text-sm text-zinc-400">Rol</span>
                  <p className="font-medium text-[#6366F1]">Administrador</p>
                </div>
              </div>

              {/* Member Since */}
              <div className="flex items-center gap-3 p-4 bg-zinc-950 rounded-xl">
                <Calendar className="w-5 h-5 text-zinc-500" />
                <div>
                  <span className="text-sm text-zinc-400">Miembro desde</span>
                  <p className="font-medium text-white">
                    {new Date(user.created_at).toLocaleDateString('es-ES', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}
                  </p>
                </div>
              </div>

              {/* Telegram Config Placeholder */}
              <div className="p-4 bg-[#6366F1]/10 border border-[#6366F1]/20 rounded-xl">
                <h3 className="font-medium text-white mb-2">🤖 Configuración de Telegram</h3>
                <p className="text-sm text-zinc-400">
                  Próximamente podrás conectar tu bot de Telegram para enviar picks automáticamente.
                </p>
              </div>
            </div>

            {/* Actions */}
            <div className="p-6 border-t border-zinc-800">
              <Button
                variant="outline"
                onClick={handleLogout}
                className="w-full border-red-500/30 text-red-400 hover:bg-red-500/10 hover:text-red-300"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Cerrar Sesión
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
